var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDubleArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    stroke: "",
    fill: "url(#linear-gradient)",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "double-down-sign",
    className: "icon glyph",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC7532FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBBD61FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13,4.51a1,1,0,0,1,1.36-.38L12,8.86l8.51-4.73a1,1,0,0,1,1,1.74l-9,5a.94.94,0,0,1-.15.06l-.09,0A1,1,0,0,1,12,11h0a1,1,0,0,1-.25,0l-.09,0a.94.94,0,0,1-.15-.06l-9-5A1,1,0,0,1,2.13,4.51Zm18.38,8.62L12,17.86,3.49,13.13a1,1,0,0,0-1,1.74l9,5,.15.06.09,0A1,1,0,0,0,12,20h0a1,1,0,0,0,.25,0l.09,0,.15-.06,9-5a1,1,0,1,0-1-1.74Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubleArrowDown);
export default __webpack_public_path__ + "static/media/duble-arrow-down.f35cc94dfabfd4aea88760970c3ea4cf.svg";
export { ForwardRef as ReactComponent };